import axios from 'axios'
import React, { Component } from 'react'
import { APIURL } from '../../hoc/AxiosSetting/axios'
import { TableTemplate } from '../../hoc/tableSetting/TableTemplate'
import { TableTemplatePageWise } from '../../hoc/tableSetting/TableTemplatePageWise'
import { COLUMNS } from './EmailDashboardListColumns'

export default class EmailDashboard extends Component {
    constructor(props) {
      super(props)
      
      this.state = {
         data:{},
      }
    }   
    componentDidMount(){
        axios.get(APIURL + '/api/mail/get/emaildata')
        .then(res=>{
            console.log("res",res.data.response)
            this.setState({data: res.data.response})
        })
        .catch(err=>
            {
                console.log("err",err)
            })
    }
  render() {
    return (
        <div>
        <div className="content-wrapper">
          <section className="content-header">
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary">
                    <div className="card-body table-responsive">
                      <div className="row">
                        <div className="col-sm-12">
                          {
                            this.state.data && this.state.data.length > 0 ?
                              this.state.data.length >= 20 ?
                                <TableTemplatePageWise userData={this.state.data} columns={  COLUMNS} />
                                :
                                <TableTemplate userData={this.state.data} columns={  COLUMNS}  />
                              :
                              <div>No Data Found</div>
                          }

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }
}